"use client";

import { Box, Grid, Skeleton, useTheme } from "@mui/material";
import Image from "next/image";
import { useState } from "react";

export function SLSubpageHeaderMedia({
  image,
  imageAlt,
}: {
  image: string;
  imageAlt: string;
}) {
  const theme = useTheme();
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  return (
    <Grid
      size={{ xs: 12, sm: 12, md: "auto", lg: "auto" }}
      sx={{
        minHeight: { xs: "300px", md: "450px" },
        minWidth: { xs: "100%", md: "450px" },
        width: { xs: "100%", md: "450px" },
        aspectRatio: "1/1",
        flexShrink: 0,
        position: "relative",
        borderRadius: {
          xs: "0 0 0 0",
          sm: "0 0 0 0",
          md: "0 20px 20px 0",
        },
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflow: "hidden",
        }}
      >
        {/* Loading placeholder sits BEHIND the image (zIndex 0). The image
            renders visible by default, so the browser can paint the LCP image
            as soon as it arrives — without waiting for React hydration. The
            skeleton is only ever seen while the image is still loading and is
            covered the instant the image paints. */}
        {!imageError && !imageLoaded && (
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            animation="wave"
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 0,
            }}
          />
        )}

        {imageError && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: theme.palette.grey[200],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: theme.palette.text.secondary,
              fontSize: "0.875rem",
              zIndex: 0,
            }}
          >
            Bild konnte nicht geladen werden
          </Box>
        )}

        {!imageError && (
          <Image
            src={image}
            alt={imageAlt}
            fill
            priority
            fetchPriority="high"
            quality={65}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 450px"
            style={{
              objectFit: "cover",
              objectPosition: "center",
              zIndex: 1,
            }}
            onLoad={() => setImageLoaded(true)}
            onError={() => {
              setImageError(true);
            }}
          />
        )}
      </Box>
    </Grid>
  );
}
